import Vue from 'vue'
import { BootstrapVue/*, BootstrapVueIcons*/ } from 'bootstrap-vue'
import VueRouter from 'vue-router'

import Login from '@/views/SignIn.vue';
import Register from '@/views/SignUp.vue';
import OAuth from "@/views/OAuth";

import SignUpForm from '@/components/sign-up/SignUpForm.vue';
import EmailVerification from '@/components/sign-up/EmailVerification';
import SignUpSteps from '@/components/sign-up/SignUpSteps';
import SignUpTitle from '@/components/sign-up/SignUpTitle';
import VerificationSuccess from '@/components/sign-up/Success'

import EmailConfirmationRequired from '@/views/EmailConfirmationRequired'

import SingOut from '@/views/SignOut'

import ForgotPassword from '@/views/password-reset/ForgotPassword';
import CheckEmail from '@/views/password-reset/CheckEmail';
import ResetPassword from '@/views/password-reset/ResetPassword';

import UserDashboard from '@/views/UserDashboard.vue';
//import UserSummary from "@/components/user-dashboard/UserSummary";
import UserRDBM from "@/components/user-dashboard/UserRDBM";
import UserRDBMLicenseList from "@/components/user-dashboard/rdbm/UserRDBMLicenseList";
import UserRDBMLicenseEditor from "@/components/user-dashboard/rdbm/UserRDBMLicenseEditor";
import UserBilling from "@/components/user-dashboard/UserBilling";
import UserBillingSummary from "@/components/user-dashboard/billing/UserBillingSummary";
import UserCheckoutResult from "@/components/user-dashboard/billing/UserCheckoutResult";


import UserProfile from "@/views/UserProfile";
import UserAccount from '@/components/user-profile/UserAccount';
import UserCommunication from '@/components/user-profile/UserCommunication';
import UserAuthentication from '@/components/user-profile/UserAuthentication';
import UserSessions from '@/components/user-profile/UserSessions';

import AdminDashboard from '@/views/AdminDashboard.vue'
import UserList from "@/components/admin-dashboard/UserList";
import RoleList from "@/components/admin-dashboard/RoleList";
import Templates from "@/components/admin-dashboard/Templates";
import ClientDetails from "@/components/admin-dashboard/ClientDetails";

import NotFound from '@/views/NotFound'


Vue.use(BootstrapVue)

Vue.use(VueRouter)

const routes = [
    { path: '/', redirect: { name: 'dashboard' } },
    {
        // здесь path и name пусть совпадают, есть проверка чтобы path заканчивался на name!
        path: '/sign-in',
        name: 'sign-in',
        component: Login,
        meta: {
            guest: true,
            menuless: true  // Центрирует контент по вертикали!
        },
        props: true
    },
    {
        path: '/sign-up',
        //name: 'sign-up',
        component: Register,
        meta: {
            guest: true,
            menuless: true  // Центрирует контент по вертикали!
        },
        props: true,
        children: [
            {
                path: '',
                name: 'sign-up-form',
                components: {
                    default: SignUpForm,
                    steps: SignUpSteps,
                    title: SignUpTitle
                },
                meta: {
                    guest: true,
                    menuless: true  // Центрирует контент по вертикали!
                },
                props: {
                    default: true,
                    steps: { step: 1 },
                    title: { title: "signup.h" }
                }
            },
            {
                path: 'email-verification',
                name: 'sign-up-verification',
                components: {
                    default: EmailVerification,
                    steps: SignUpSteps,
                    title: SignUpTitle
                },
                meta: {
                    guest: true,
                    menuless: true  // Центрирует контент по вертикали!
                },
                props: {
                    default: true,
                    steps: { step: 2 },
                    title: { title: "verification.h" }
                }
            },
        ]
    },
    {
        path: '/sign-up/success',
        name: 'verificationSuccess',
        component: VerificationSuccess,
        meta: {
            requiresAuth: true,
            menuless: true  // Центрирует контент по вертикали!
        }
    },
    {
        path: '/forgot-password',
        name: 'forgotPassword',
        component: ForgotPassword,
        meta: {
            guest: true,
            menuless: true  // Центрирует контент по вертикали!
        }
    },
    {
        path: '/check-email',
        name: 'checkEmail',
        component: CheckEmail,
        meta: {
            guest: true,
            menuless: true  // Центрирует контент по вертикали!
        }
    },
    {
        path: '/reset-password/:token',
        name: 'resetPassword',
        component: ResetPassword,
        meta: {
            guest: true,
            menuless: true  // Центрирует контент по вертикали!
        },
        props: true
    },
    {
        path: '/confirm-email',
        name: 'confirmEmail',
        component: EmailConfirmationRequired,
        meta: {
            guest: true,
            menuless: true  // Центрирует контент по вертикали!
        },
        props: true
    },
    //    { path: '/dashboard', redirect: { name: 'profile' }},
    {
        path: '/dashboard',
        name: 'dashboard',
        // Перенаправление сразу на список лицензий не работает, поэтому постепенно до rdbmList!
        redirect: { name: 'rdbm' },
        component: UserDashboard,
        meta: {
            requiresAuth: true
        },
        children: [
            /*
            {
                path: 'summary',
                name: 'userDashboard',
                component: UserSummary
            },

             */
            {
                path: '',
                name: 'rdbm',
                // Перенаправление сразу на список лицензий не работает, поэтому постепенно до rdbmList!
                redirect: { name: 'rdbmList' },
                component: UserRDBM,
                children: [
                    {
                        path: 'rdbm',
                        name: 'rdbmList',
                        component: UserRDBMLicenseList
                    },
                    {
                        path: 'rdbm/:id',
                        name: 'rdbmItem',
                        component: UserRDBMLicenseEditor,
                        props: true
                    }
                ]
            },
            {
                path: 'billing',
                component: UserBilling,
                children: [
                    {
                        path: '',
                        name: 'userBilling',
                        component: UserBillingSummary
                    },
                    {
                        path: 'success',
                        name: 'checkoutSuccess',
                        component: UserCheckoutResult,
                        props: (route) => ({
                            action: 'success',
                            provider: route.query.provider,
                            session_id: route.query.session_id,
                            licenseId: route.query.id
                        }),
                        meta: {
                            guest: true,
                        }
                    },
                    {
                        path: 'cancel',
                        name: 'checkoutCanceled',
                        component: UserCheckoutResult,
                        props: (route) => ({
                            action: 'canceled',
                            provider: route.query.provider,
                            session_id: route.query.session_id,
                            licenseId: route.query.id
                        }),
                        meta: {
                            guest: true,
                        }
                    },
                ]
            }
        ]
    },
    {
        path: '/dashboard/profile',
        redirect: { name: 'account' },
        component: UserProfile,
        meta: {
            requiresAuth: true
        },
        children: [{
            path: 'account',
            name: 'account',
            component: UserAccount
        }, {
            path: 'comm',
            name: 'communication',
            component: UserCommunication
        }, {
            path: 'auth',
            name: 'authentication',
            component: UserAuthentication
        },
        {
            path: 'sessions',
            name: 'sessions',
            component: UserSessions
        }]
    },
    { path: '/admin', redirect: { name: 'clientsList' } },
    {
        path: '/admin',
        name: 'admin',
        component: AdminDashboard,
        meta: {
            requiresAuth: true,
            adminOnly: true
        },
        children: [
            {
                path: 'clients',
                name: 'clientsList',
                component: UserList
            },
            {
                path: 'clients/:id',
                name: 'clientDetails',
                component: ClientDetails,
                props: {
                    default: true
                }
            },
            {
                path: 'roles',
                component: RoleList
            },
            {
                path: 'templates',
                component: Templates
            }
        ]
    },
    {
        path: '/confirm/:token',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/EmailConfirmationLink.vue'),
        meta: {
            guest: true,
            menuless: true  // Центрирует контент по вертикали!
        },
        props: true
    },
    {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')

    },
    {
        path: '/sign-out',
        name: 'sign-out',
        component: SingOut,
        meta: {
            guest: true,
            menuless: true  // Центрирует контент по вертикали!
        }
    },
    {
        path: '/oauth/:provider',
        name: 'oauth',
        component: OAuth,
        meta: {
            guest: true,
            menuless: true  // Центрирует контент по вертикали!
        },
        props: (route) => ({
            provider: route.params.provider,
            code: route.query.code,
            state: route.query.state
        }),
    },
    {
        path: '/404',
        component: NotFound,
        meta: {
            menuless: true  // Центрирует контент по вертикали!
        }
    },
    { path: '/test', redirect: { name: 'test-font' } },
    {
        path: '/test',
        component: () => import(/* webpackChunkName: "about" */ '../views/ThemePreviewAndTesting.vue'),
        meta: {
            requiresAuth: true,
            adminOnly: true
        },
        props: true,
        children: [
            {
                path: 'font',
                name: 'test-font',
                component: () => import(/* webpackChunkName: "about" */ '../components/testing/Font.vue')
            },
            {
                path: 'components',
                name: 'test-components',
                component: () => import(/* webpackChunkName: "about" */ '../components/testing/Components.vue')
            },
            {
                path: 'pages',
                name: 'test-pages',
                component: () => import(/* webpackChunkName: "about" */ '../components/testing/Pages.vue')
            }
        ]
    },
    { path: '*', redirect: '/404' },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior: function (to, from, savedPosition) {
        if (savedPosition) {
            // savedPosition is only available for popstate navigations.
            return savedPosition
        } else {
            const position = {}

            // scroll to anchor by returning the selector
            if (to.hash) {
                position.selector = to.hash
                position.offset = { y: 20 }

                // bypass #1number check
                if (/^#\d/.test(to.hash) || document.querySelector(to.hash)) {
                    return position
                }

                // if the returned position is falsy or an empty object,
                // will retain current scroll position.
                return false
            }
        }
    },
})

//import user from '@/util/user.js'
import store from '@/store'

router.beforeEach((to, from, next) => {
    /* Debug */
    if (window._prefetch_start) {
        console.log('router.beforeEach is ' + (Date.now() - window._prefetch_start) + ' ms after prefetch.')
        //console.log('to:', to, " from: ", from)
        window._prefetch_start = null
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
        // Путь требует аутентификации
        if (!store.getters.isComplete()) {
            // Не аутентифицированный пользователь, перенаправляем на логин
            next({
                name: 'sign-in',
                params: { nextUrl: to.fullPath }
            })
        } else {
            // Пользователь аутентифицированный, идет ли он на страницу только для админов?
            if (to.matched.some(record => record.meta.adminOnly)) {
                if (store.getters.isAdmin) {
                    next()
                } else {
                    // Не Админ, перенаправим на главную страницу Клиента
                    next({ name: 'dashboard' })
                }
            } else {
                next()
            }
        }
    } else {
        next()
    }
})

export default router
